"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.optionButton = exports.Wrapper = exports.FocusState = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
var _react2 = require("motion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)(_react2.motion.div, process.env.NODE_ENV === "production" ? {
  target: "egkzt9c0"
} : {
  target: "egkzt9c0",
  label: "Wrapper"
})(props => /*#__PURE__*/(0, _react.css)("padding:0.65em 1em;border-radius:", props.lightTheme ? '19px' : '7px', ";border:1px solid transparent;transition:border-color 0.1s ease-in-out;background:", props.active ? props.background : 'transparent', ";box-shadow:", props.active ? '0 2px 4px 0 rgba(9, 28, 68, 0.2)' : 'none', ";&>span{font-size:14px;}" + (process.env.NODE_ENV === "production" ? "" : ";label:Wrapper;")));
const optionButton = exports.optionButton = process.env.NODE_ENV === "production" ? {
  name: "m3111f",
  styles: "padding-left:8px;justify-content:flex-start;height:100%;width:100%"
} : {
  name: "1m0yxkj-optionButton",
  styles: "padding-left:8px;justify-content:flex-start;height:100%;width:100%;label:optionButton;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const FocusState = color => /*#__PURE__*/(0, _react.css)("&:focus{text-decoration:none;div{border-color:", color, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:FocusState;"));
exports.FocusState = FocusState;